// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__h68Gz","switch__slider":"Toggle_switch__slider__JKFGz"};